import ApprovalVendorTable from "./ApprovalVendorTable";

export default ApprovalVendorTable;
